import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CartLoading from './CartLoading';
import { getUserCart, removeItemFromCart, addItemToCart } from './../../../apis/requests';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { formatPrice } from '../../../utils/utils';
import { InputNumber } from "primereact/inputnumber";
import { Button } from 'primereact/button';
import store from '../../redux/store';
import { setCartCount } from '../../redux/reducer';
import useLang from '../../../hooks/useLang';
import { DataView } from 'primereact/dataview';



const Cart = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [cartItems, setCartItems] = useState([]);
    useEffect(() => {
        loadGetuserCart();
    }, []);
    const loadGetuserCart = async () => {
        try {
            let params = {
                cart_id: localStorage.getItem('cart'),
            }
            const res = await getUserCart(params);
            setCartItems(res.data.cartItems);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }
    const getCartTotalPrice = (op = 'sum') => {
        let sum = 0;
        let saved = 0;
        cartItems.forEach((citem) => {
            if (citem.discount_end_date === null) {
                sum += citem.item_sale_price_without_discount * citem.item_quantity;
            } else {
                let discount_end_date = new Date(citem.discount_end_date);
                if (discount_end_date <= Date.now()) {
                    sum += citem.item_sale_price_without_discount * citem.item_quantity;
                } else {
                    sum += citem.item_sale_price * citem.item_quantity;
                    saved += citem.item_discount * citem.item_quantity;
                }
            }
        });
        if (op === "sum") {
            return formatPrice(sum);
        } else {
            return formatPrice(saved);
        }
    }

    const listTemplate = (items) => {
        if (!items || items.length === 0) return null;

        let list = items.map((product, index) => {
            return itemTemplate(product, index);
        });

        return <div className="grid grid-nogutter">{list}</div>;
    };
    const itemTemplate = (product, index) => {
        return (
            <div className="mb-3" key={product.id}>
                <CartItem
                    index={index}
                    item={product}
                    onItemUpdate={(remain) => {
                        setCartItems(remain);
                        store.dispatch(setCartCount(remain.length));
                    }}
                    setCart={(val) => {
                        setCartValue(val);
                    }}
                />
                <hr
                    style={{
                        borderColor: "#CCC",
                        borderRadius: 10
                    }}
                />
            </div>
        );
    };

    return (
        <div className='lg:p-10 '>

            {
                loading &&
                <CartLoading />
            }
            {
                (!loading && cartItems.length === 0) &&
                <div className='flex content-center' >
                    <div className='text-center mb-4'>
                        <img src='/svg/landing.svg' alt='no_data' className='w-150' />
                        <Link to="/shop">{t('empty_cart_msg')}</Link>
                    </div>
                </div>
            }
            {
                (!loading && cartItems.length !== 0) &&
                <div className='p-3'>
                    <h1 className='text-3xl mt-3'>{t('your_shopping_cart')}</h1>
                    <div className="grid gap-3 grid-cols-1 sm:grid-cols-12 py-4">
                        <div className="col-span-12 md:col-span-12 lg:col-span-7">
                            <div className="grid grid-cols-12 md:grid-cols-12 sm:grid-cols-12 xs:grid-cols-12 gap-1 items-center mb-4">
                                <div className="col-span-2">

                                </div>
                                <div className="lg:col-span-4 md:col-span-4 col-span-7">
                                    <span className='font-semibold text-gray-600'>{t('item')}</span>
                                </div>
                                <div className="lg:col-span-3 md:col-span-3 lg:block md:block hidden">
                                    <span className='font-semibold text-gray-600'>{t('quantity')}</span>
                                </div>
                                <div className="lg:block md:block hidden col-span-2">
                                    <span className='font-semibold text-gray-600'>{t('total')}</span>
                                </div>
                                <div className="col-span-1">
                                    <span className='font-semibold text-gray-600'>{t('delete')}</span>
                                </div>
                            </div>
                            <hr
                                style={{
                                    borderColor: "#CCC",
                                    borderRadius: 10,
                                    marginBottom: 10
                                }}
                            />
                            <div className='lg:mx-5 mx-2'>
                                <DataView value={cartItems} listTemplate={listTemplate} />
                            </div>
                        </div>
                        <div className="col-span-12 lg:col-span-5">
                            <div className='bg-gray-100 rounded-md lg:p-7 p-2'>
                                <div className='mt-3'>
                                    <span className='text-2xl p-2 font-semibold'>{t('cart_summary')}</span>
                                </div>
                                <div className='p-3'>
                                    <div className="flex justify-between mb-4">
                                        <span className='font-semibold'>{t('total_items')}</span>
                                        <span className='text-xl'><strong>{cartItems.length}</strong></span>
                                    </div>

                                    <div className="flex justify-between mb-4">
                                        <span className='font-semibold'>{t('total_quantity')}</span>
                                        <span><strong className='text-xl'>{cartItems.reduce((a, b) => a + (b.item_quantity), 0)}</strong> <span>{t('items')}</span></span>
                                    </div>

                                    <div className="flex justify-between mb-4">
                                        <span className='font-semibold'>{t('sub_total')}</span>
                                        <span className='text-xl'><strong>{formatPrice(cartItems.reduce((a, b) => a + (b.item_sale_price_without_discount * b.item_quantity), 0))}</strong></span>
                                    </div>
                                    <div className="flex justify-between mb-4">
                                        <span className='font-semibold'>{t('you_saved')}</span>
                                        <span className='text-xl text-red-600'>-<strong>{getCartTotalPrice('saved')}</strong></span>
                                    </div>
                                    <div className="flex justify-between mb-4">
                                        <span className='font-semibold'>{t('shipping')}</span>
                                        <span className='text-base'><strong>{t('calculated_at_checkout')}</strong></span>
                                    </div>
                                    <hr />
                                    <div className="flex justify-between mt-4">
                                        <span className='text-xl font-semibold'>{t('estimated_total')}</span>
                                        <span className='text-xl'><strong>{getCartTotalPrice()}</strong></span>
                                    </div>
                                    <div className='mt-4'>
                                        <Button label={t('checkout_cart')} rounded
                                            severity="secondary"
                                            onClick={() => {
                                                navigate('/checkout')
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}
export default Cart;
const CartItem = (props) => {
    const index = props.index;
    const { t } = useTranslation();
    const lang = useLang();
    const item = props.item;
    const product = JSON.parse(item.product);
    const productFields = JSON.parse(item.product_fields);
    const [quantity, setQuantity] = useState(item.item_quantity);
    const [loading, setLoading] = useState(false);
    const [itemPrice, setItemPrice] = useState({ price: 0, discount: false });
    const handleRemoveItemFromCart = async () => {
        try {
            setLoading(true);
            let params = {
                id: item.id,
            }
            const res = await removeItemFromCart(params);
            props.onItemUpdate(res.data.cartItems);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);

        }
    }
    const handleAddItemToCart = async (calculatedQuantity) => {
        try {
            setLoading(true);
            let guestCartId = localStorage.getItem('cart') === null ? crypto.randomUUID() : localStorage.getItem('cart');
            let data = {
                cart_id: guestCartId,
                quantity: calculatedQuantity,
                product: {
                    id: item.product_id,
                    fields: productFields,
                }
            }
            const res = await addItemToCart(data);
            store.dispatch(setCartCount(res.data.cart_count));
            props.onItemUpdate(res.data.cartItems);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }
    useEffect(() => {
        if (item.discount_end_date === null) {
            setItemPrice({
                price: formatPrice(item.item_sale_price_without_discount),
                discount: false,
            })
        } else {
            let discount_end_date = new Date(item.discount_end_date);
            if (discount_end_date <= Date.now()) {
                setItemPrice({
                    price: formatPrice(item.item_sale_price_without_discount),
                    discount: false
                });
            } else {
                setItemPrice({
                    price: formatPrice(item.item_sale_price),
                    discount: true
                });
            }
        }
    }, []);
    return (
        <div className="grid grid-cols-12 md:grid-cols-12 sm:grid-cols-12 xs:grid-cols-12 gap-1 items-center mb-3">
            <div className="col-span-2">
                <div>
                    <img src={product.image} className='w-25 bg-gray-100 rounded-md' alt='logo' />
                </div>
            </div>
            <div className="lg:col-span-4 md:col-span-4 col-span-8">
                <Link
                    to={'/shop/products/' + product.name + '/' + product.sku}
                    state={product}
                >
                    <span className='font-semibold'>{lang === "en" ? product.name : product.name_ar}</span>
                </Link>
                <div className='mt-1'>
                    <span className='font-semibold text-gray-600'>{itemPrice.price}</span>
                    {
                        itemPrice.discount &&
                        <span className="text-sm mx-1"
                            style={{
                                textDecorationLine: "line-through"
                            }}
                        >{formatPrice(product.selling_price, false)}</span>
                    }
                </div>
                <div className='mt-1'>
                    {
                        Object.entries(productFields).map((f, index) => {
                            return (
                                <p key={index}><span className='opacity-50'>{f[1][lang]} :</span>  {f[1]['value']}</p>
                            );
                        })
                    }
                </div>
                <div className="lg:col-span-4 md:col-span-4 lg:hidden md:hidden mt-2">
                    <div className="flex items-center">
                        <div className="mx-2">
                            <Button rounded outlined severity="secondary"
                                onClick={() => {
                                    if (quantity >= 2) {
                                        setQuantity(quantity - 1);
                                    }
                                }}
                                style={{
                                    height: 30,
                                    width: 30
                                }}
                                icon={<span className="material-symbols-outlined">
                                    remove
                                </span>}
                            />
                        </div>
                        <div className="w-25">
                            <InputNumber className="sm-prod-view-checkout-qun-input"
                                style={{
                                    borderRadius: 30,
                                }}
                                readOnly
                                disabled
                                value={quantity}
                            />
                        </div>
                        <div className="mx-2">
                            <Button rounded outlined severity="secondary"
                                onClick={() => {
                                    setQuantity(quantity + 1);
                                }}
                                style={{
                                    height: 30,
                                    width: 30
                                }}
                                icon={<span className="material-symbols-outlined">
                                    add_2
                                </span>}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="lg:col-span-3 md:col-span-3 lg:block md:block hidden">
                <div className="flex items-center">
                    <div className="mx-1">
                        <Button rounded outlined severity="secondary"
                            loading={loading}
                            onClick={() => {
                                if (quantity >= 2) {
                                    let calculatedQuantity = quantity - 1;
                                    setQuantity(calculatedQuantity);
                                    handleAddItemToCart(calculatedQuantity);
                                }
                            }}
                            style={{
                                height: 30,
                                width: 30
                            }}
                            icon={<span className="material-symbols-outlined">
                                remove
                            </span>}
                        />
                    </div>
                    <div className="w-20">
                        <InputNumber className="prod-view-checkout-qun-input"
                            style={{
                                borderRadius: 30
                            }}
                            readOnly
                            disabled
                            value={quantity}
                        />
                    </div>
                    <div className="mx-1">
                        <Button rounded outlined severity="secondary"
                            onClick={() => {
                                setQuantity(quantity + 1);
                                let calculatedQuantity = quantity + 1;
                                setQuantity(calculatedQuantity);
                                handleAddItemToCart(calculatedQuantity);

                            }}
                            style={{
                                height: 30,
                                width: 30
                            }}
                            icon={<span className="material-symbols-outlined">
                                add_2
                            </span>}
                        />
                    </div>
                </div>
            </div>
            <div className="col-span-2 lg:block md:block hidden">
                <span className='font-semibold'>{formatPrice(item.item_quantity * item.item_sale_price)}</span>
            </div>
            <div className="col-span-1">
                <div>
                    {
                        <Button
                            style={{
                                height: 30,
                                width: 30,
                                border: 0
                            }}
                            loading={loading}
                            onClick={() => {
                                handleRemoveItemFromCart();
                            }}
                            outlined
                            severity='danger' rounded icon={<span className="material-symbols-outlined">
                                close
                            </span>}
                        />
                    }

                </div>
            </div>
        </div>
    );
}
CartItem.propTypes = {
    item: PropTypes.object.isRequired,
    onItemUpdate: PropTypes.func.isRequired
}